// implement your own methods in here, if your data is coming from A rest API

import * as Template from './template'
import * as Agreement from './agreement'
import * as Requirement from './requirement'
import * as Category from './category'
import * as Company from './company'
import * as User from './user'

export {
  // 동의서 템플릿 카테고리
  Category,
  // 동의서 템플릿
  Template,
  // 사용자 동의서
  Agreement,
  // 필수 데이터 목록
  Requirement,
  // 회사 정보
  Company,
  // 사용자 정보
  User,
}




// WEBPACK FOOTER //
// ./src/api/index.js